"use client";

import QuestionLayout from "@/app/layout/question";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";

import DescriptionContent from "./components/description-section";
import FormContent from "./components/form-content";
import useTravelDatesHooks from "./hooks/travel-dates.hooks";
import { useTravelDatesContext } from "./providers/travel-dates.provider";

function TravelDates() {
  const { current } = useWizard();
  const {
    handleBackButton,
    handleSubmitButton,
    isFooterLoading,
    loading,
    editPage,
    isQuoteReviewCoverEdit,
  } = useTravelDatesHooks();
  const { travelDates, magnoliaData, scrollRefArray, isDateError } =
    useTravelDatesContext();
  const { ctaButtonText, finishEditingBtnText } = magnoliaData.overlayArea[0];

  return (
    <QuestionLayout
      formSection={<FormContent />}
      descriptionContent={<DescriptionContent />}
      footer={{
        isHideFooterBack: false,
        isLoading: loading || isFooterLoading,
        isDisabledBack: false,
        isDisabledContinue:
          travelDates.startDate === null ||
          travelDates.endDate === null ||
          travelDates.validate === false ||
          isDateError,
        footerActionBack: () => {
          handleBackButton();
        },
        footerActionContinue: () => {
          handleSubmitButton();
        },
        id: "travel-dates",
        brand: "staysure",
        ctaButtonText:
          editPage && !isQuoteReviewCoverEdit
            ? finishEditingBtnText
            : ctaButtonText,
      }}
      progressBarPercent={current.progressBarPercentage}
      scrollRefs={scrollRefArray}
    />
  );
}
export default TravelDates;
